import React from 'react'

const SyncAndIntegration = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
Sync and Integration
      </div>
      </div>
  )
}

export default SyncAndIntegration